import axios from 'axios';
import { retry } from '../utils/promise-helpers';

const url = process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
	api = axios.create({ baseURL: url }),
	apiBackground = axios.create({ baseURL: url }),
	getSessionState = async () => {
		const { store } = await import('src/states/store');
		const state = store.getState();
		return state.session;
	},
	refreshTokenDispatch = (refreshToken) =>
		apiBackground
			.post('/users/refresh-token', { refreshToken })
			.then((response) => response.data)
			.then((data) => data.body),
	logOut = async () => {
		const { store } = await import('src/states/store');
		const { logout } = await import('src/states/modules/session');
		store.dispatch(logout());
	},
	updateStore = async (data) => {
		const { token, refreshToken } = data;

		const { store } = await import('src/states/store');
		const { setNewRefreshTokenSuccess } = await import('src/states/modules/session');
		store.dispatch(setNewRefreshTokenSuccess(data));

		api.defaults.headers.Authorization = `Bearer ${token}`;
		return token;
	};

//An unauthorized request means the token has expired. We will try to get a new one with our valid refreshToken.
//If we succeed the new token and refreshToken wll be saved in LocalStore and we resend the request.
//Otherwise, if it fails more than 3 times or if the refreshToken is expired the user will be logged out.
api.interceptors.response.use(
	(response) => response,
	async (error) => {
		const { status, config } = error.response || {};
		const state = await getSessionState();
		const { refreshToken, signed } = state;
		if (status === 401 && signed) {
			return retry(3, 500, refreshTokenDispatch, refreshToken)
				.then(updateStore)
				.then((token) => {
					if (token) {
						config.headers.Authorization = `Bearer ${token}`;
						return api.request(config);
					}
				})
				.catch(async (err) => {
					await logOut();
					throw err;
				});
		}

		return Promise.reject(error);
	},
);

export const getApiUrl = () => url;
export default api;
